// errorIds is the Set of control ids the wizard marks invalid, the same shape
// the faculty wizard passes its sections. An absent set means no errors.
export function hasError(errorIds, id) {
    return Boolean(errorIds && errorIds.has(id));
}

// context.fieldErrors maps a control id to the message the server gave for it
// when it refused a submit. The wizard clears an entry once the answer changes.
export function fieldMessage(context, id) {
    return context?.fieldErrors?.[id] || null;
}
